<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="row">
      <div class="col-md-8 ts-space-y-3">
        <div class="row">
          <label class="col-md-3 form-col-label control-label required">{{
            $t('tradeIn.saleInvoiceNumber')
          }}</label>
          <div class="col-md-7">
            <a-select
              v-model="model.ref_stock_out_id"
              class="ts-w-full"
              :options="saleInvoices"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="onSaleInvoiceChange"
              :placeholder="$t('select')"
              :class="{ 'is-invalid': errors.has('ref_stock_out_id') }"
            ></a-select>
            <div class="validate" v-if="errors.has('ref_stock_out_id')">
              {{ errors.first('ref_stock_out_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-md-3 form-col-label control-label required">{{
            $t('tradeIn.tradeInDate')
          }}</label>
          <div class="col-md-7">
            <a-date-picker
              class="ts-w-full"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              v-model="model.trade_in_date"
              :class="{ 'is-invalid': errors.has('trade_in_date') }"
            ></a-date-picker>
            <div class="validate" v-if="errors.has('trade_in_date')">
              {{ errors.first('trade_in_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-md-3 form-col-label control-label required">{{
            $t('tradeIn.fxRate')
          }}</label>
          <div class="col-md-7">
            <input
              v-model="model.fx_rate"
              type="text"
              readonly
              class="form-control"
            />
            <div class="validate" v-if="errors.has('fx_rate')">
              {{ errors.first('fx_rate') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'info',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    ...mapState('stock/tradeIn', ['formViewDatas']),
    saleInvoices() {
      if (this.formViewDatas['saleInvoice']) {
        return this.formViewDatas['saleInvoice'].map(el => ({
          value: el.stock_out_id,
          label:
            el.invoice_no +
            (el.customer ? ` | ${el.customer.customer_name}` : ''),
          customer_id: el.customer_id,
          reference_no: el.invoice_no
        }))
      }
      return []
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('stock/tradeIn', ['getFormViewModel']),
    async onSaleInvoiceChange(value, option) {
      this.model.product_details = []
      this.model.customer_id = option.data.props.customer_id
      this.model.reference_no = option.data.props.reference_no
      this.$emit('loading', true)
      return this.getFormViewModel({
        index: 'saleInvoiceDetail',
        params: {
          fnName: 'saleInvoiceDetail',
          stock_out_id: value
        }
      })
        .then(response => {
          this.setData(response.data.saleInvoiceDetail)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    setData(data) {
      this.model.ref_stock_out_id = data.stock_out_id
      this.model.customer_id = data.customer_id
      this.model.reference_no = data.invoice_no
      let invoiceProducts = data.details.map(el => {
        return {
          product_id: el.product_id,
          barcode: el.barcode,
          product_name_en: el.product_name_en,
          product_name_kh: el.product_name_kh,
          uom_id: el.uom_id,
          uom_name_en: el.uom_name_en,
          uom_name_kh: el.uom_name_kh,
          pro_group_name_en: el.pro_group_name_en,
          pro_group_name_kh: el.pro_group_name_kh,
          cost: el.cost,
          input_cost: el.cost,
          currency_id: el.currency_id,
          fx_rate: el.fx_rate,
          fx_rate_ratio: el.fx_rate_ratio,
          input_currency_id: el.input_currency_id,
          is_generate_unique_serial: el.is_generate_unique_serial,
          serial_list: el.serial_list_sold
        }
      })
      this.$store.commit('stock/tradeIn/SET_INVOICE_PRODUCTS', invoiceProducts)
      this.$emit('showProductList')
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
